'use strict';

module.exports = require('ck-core/source/functions/makeLang')({
	BUTTONS: {
		REACTIVATE_SUBSCRIPTION: 'Reactivate subscription',
		CANCEL_SUBSCRIPTION: 'Cancel subscription',
		UPDATE_DETAILS: 'Update Payment Details',
		CHANGE_PLAN: 'Change Plan'
	}
});
